<template>
    <div>
        <div>
            <label
                class="mb-1 block text-sm font-medium"
                for="name"
                >{{ $t('file') }} <span class="text-danger-500">*</span></label
            >
        </div>
        <FileUploadButton
            title="asset_signature_document"
            accept=".pdf"
            :file-name="modelValue.name"
            :url="modelValue.url"
            @submit="onFileSubmit"
            @delete="onFileDelete"
        />
        <div>
            <input
                v-if="fileName"
                v-model="fileName"
                class="form-input w-full bg-gray-200"
                type="text"
                disabled
            />
        </div>
    </div>
    <div>
        <TextField
            v-model="modelValue.name"
            name="name"
            label="name"
            help="help_file_name"
            :required="true"
        />
    </div>
    <div>
        <SelectField
            v-model="modelValue.language"
            name="language"
            label="language"
            :options="Object.values(languages)"
            :required="true"
        />
    </div>
    <div>
        <SelectField
            v-model="modelValue.type"
            name="type"
            label="type"
            help="help_file_type"
            :options="[
                {
                    label: $t('terms'),
                    value: 'terms',
                },
                {
                    label: $t('information_letter'),
                    value: 'information_letter',
                },
            ]"
            :required="true"
        />
    </div>
</template>
<script setup lang="ts">
import { SelectField, TextField } from '@src/components'
import { PlatformAttachment } from '@src/types'
import { useLanguageStore } from '@src/utils/stores/languages'
import { useFileDialog } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { Ref, ref, toRefs, watch } from 'vue'
import FileUploadButton from '../actions/FileUploadButton.vue'

const props = defineProps<{
    modelValue: Ref<PlatformAttachment>
}>()

const { modelValue } = toRefs(props)
const emit = defineEmits(['update:modelValue'])

const {
    files,
    open: openFileDialogReal,
    reset,
} = useFileDialog({ multiple: false, accept: '.pdf' })
const fileName = ref<string | null>(null)

const languageStore = useLanguageStore()
const { languages } = storeToRefs(languageStore)

function openFileDialog(): void {
    openFileDialogReal()
}

function resetForm(): void {
    reset()
    modelValue.value = new PlatformAttachment()
}

const onFileSubmit = (response, fileName) => {
    modelValue.value.url = response.temp_storage_url
    modelValue.value.name = fileName
    modelValue.value.upload_key = response.key
}

const onFileDelete = () => {
    modelValue.value.url = null
    modelValue.value.name = null
    modelValue.value.upload_key = null
}

watch(files, (files) => {
    fileName.value = files?.item(0)?.name ?? null
    modelValue.value.name = files?.item(0)?.name ?? null
})

watch(modelValue.value, (value) => {
    emit('update:modelValue', value, files)
})
</script>
